import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useDeleteAppraisalMutation = (workspaceId?: string) => {
  const { appraisals } = useAvApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-appraisal-mutation'],
    mutationFn: async (appraisalId: string) => {
      if (!workspaceId || !appraisalId) return;

      const res = await appraisals.deleteAppraisalsByIdAndProjectId({
        id: appraisalId,
        projectId: workspaceId
      });

      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['workspace-appraisals', workspaceId],
      });
    },
  });
};
